import { Field, Dropdown } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { EMPTY_LIST } from '@/lib/utils';

/**
 * Props:
 *   options   country options from buildCountryOptions
 *   required  the declaration form requires it; the contract/shipment forms do not
 *   disabled  locks the control
 */
export const CountryOfOriginField = ({
  options = EMPTY_LIST,
  required = false,
  disabled = false,
}) => {
  const t = useTranslations();

  return (
    <Field name="countryOfOrigin" required={required}>
      {({ id, name, value, onChange, onBlur, status, message, required: isRequired }) => (
        <Dropdown
          searchable
          id={id}
          name={name}
          label={required ? t('FIELD_COUNTRY_OF_ORIGIN') : t('FORM_COUNTRY_OF_ORIGIN')}
          placeholder={t('FORM_COUNTRY_OF_ORIGIN_PLACEHOLDER')}
          searchPlaceholder={t('COMMON_SEARCH_COUNTRY')}
          noResultsMessage={t('COMMON_NO_MATCHES')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
          required={isRequired}
          disabled={disabled}
          options={options}
        />
      )}
    </Field>
  );
};
